import { DelegationTarget } from "@/stores/delegation-store";
import { apiClient } from "./api";

export interface DelegationTargetsResponse {
  targets: DelegationTarget[];
}

export class DelegationAPI {
  // Get available delegation targets for the current user
  static async getAvailableTargets(): Promise<DelegationTarget[]> {
    const response = await apiClient.get<DelegationTargetsResponse>(
      "/v1/delegation/targets"
    );
    return response.data.targets;
  }
}
